import { Outlet, Navigate } from 'react-router-dom'
import { useAppSelector } from './store/hooks'

function AuthorizedRoute() {
  const { token } = useAppSelector((state) => state.currentUser)

  return token ? <Outlet /> : <Navigate to="/login" />
}

export default AuthorizedRoute
